module.exports = __webpack_public_path__ + "img/numeralia_home5.5b67c820.svg";